import { render, staticRenderFns } from "./BatchDefine.vue?vue&type=template&id=8e4cfd56"
import script from "./BatchDefine.vue?vue&type=script&lang=js"
export * from "./BatchDefine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports